import React from 'react';

const SkeletonBase = ({ style, className = '' }) => (
  <div className={`skeleton-pulse ${className}`} style={{
    background: 'var(--border)',
    borderRadius: '8px',
    animation: 'skeletonPulse 1.5s ease-in-out infinite',
    ...style,
  }} />
);

export const StatCardSkeleton = () => (
  <div className="stat-card" style={{ background: 'var(--bg-card)' }}>
    <div className="d-flex justify-content-between">
      <div style={{ flex: 1 }}>
        <SkeletonBase style={{ width: '60%', height: '14px', marginBottom: '10px' }} />
        <SkeletonBase style={{ width: '40%', height: '28px' }} />
      </div>
      <SkeletonBase style={{ width: '44px', height: '44px', borderRadius: '12px' }} />
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5, cols = 5 }) => (
  <div className="table-container" style={{ padding: '1rem' }}>
    <SkeletonBase style={{ width: '100%', height: '40px', marginBottom: '8px' }} />
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: 'flex', gap: '1rem', marginBottom: '8px' }}>
        {Array.from({ length: cols }).map((_, j) => (
          <SkeletonBase key={j} style={{ flex: 1, height: '20px' }} />
        ))}
      </div>
    ))}
  </div>
);

export const ChartSkeleton = ({ height = 300 }) => (
  <div className="stat-card" style={{ padding: '1.5rem' }}>
    <SkeletonBase style={{ width: '40%', height: '18px', marginBottom: '1rem' }} />
    <SkeletonBase style={{ width: '100%', height: `${height - 60}px`, borderRadius: '12px' }} />
  </div>
);

export const CardSkeleton = ({ count = 4 }) => (
  <div className="row g-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="col-md-3">
        <StatCardSkeleton />
      </div>
    ))}
  </div>
);

export const DetailSkeleton = () => (
  <div style={{ padding: '1rem' }}>
    <SkeletonBase style={{ width: '50%', height: '24px', marginBottom: '1.5rem' }} />
    <div className="row g-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="col-md-4">
          <SkeletonBase style={{ width: '100%', height: '16px', marginBottom: '4px' }} />
          <SkeletonBase style={{ width: '70%', height: '20px' }} />
        </div>
      ))}
    </div>
  </div>
);

export const CallPopupSkeleton = () => (
  <div className="call-popup glass-card" style={{ padding: '2rem', textAlign: 'center' }}>
    <SkeletonBase style={{ width: '100px', height: '100px', borderRadius: '50%', margin: '0 auto 1.5rem' }} />
    <SkeletonBase style={{ width: '60%', height: '16px', margin: '0 auto 0.5rem' }} />
    <SkeletonBase style={{ width: '40%', height: '14px', margin: '0 auto 2rem' }} />
    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <SkeletonBase key={i} style={{ width: '60px', height: '60px', borderRadius: '50%' }} />
      ))}
    </div>
  </div>
);

export default SkeletonBase;

// Inject skeleton animation keyframes
const style = document.createElement('style');
style.textContent = `
  @keyframes skeletonPulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
  }
`;
if (!document.getElementById('skeleton-styles')) {
  style.id = 'skeleton-styles';
  document.head.appendChild(style);
}
